import { Form } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useGetHotel } from 'app/hooks/data/hotels/useHotel';
import { useHotelSpacesTypes } from 'app/hooks/data/useHotelSpacesTypes';

import { SpacesSelect, getSpaceLabel } from './SpacesSelect';

export const RelatedSpaces = () => {
  const { mode, isViewMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();

  const hotelId = Form.useWatch(['hotelId'], form);
  const spaceIds = Form.useWatch(['spaceIds'], form);

  const { data: hotel } = useGetHotel(hotelId);

  const hotelSpaces = hotel?.spaces || [];

  const { data: spaceTypes } = useHotelSpacesTypes();

  const listOfSelectedSpaces = hotelSpaces
    .filter((space) => spaceIds?.includes(space.id))
    .map((space) => getSpaceLabel(space, spaceTypes ?? []));

  return (
    <FormLineLayout
      label="Related space(s)"
      isOptional
      description="Link this activity to the space(s) where it takes place"
      disabled={isViewMode}
    >
      <Form.Item name="spaceIds">
        {isViewMode ? (
          <span className="view-data">
            {listOfSelectedSpaces.join(', ') || 'ø empty'}
          </span>
        ) : (
          <SpacesSelect
            hotelSpaces={hotelSpaces || []}
            spaceTypes={spaceTypes ?? []}
            mode={mode}
            setFieldsValue={() => {
              /* no-op */
            }}
            notApplicableOption
          />
        )}
      </Form.Item>
    </FormLineLayout>
  );
};
